require('jquery-match-height');

/**
 * @description コンテンツ内高さ統一
 */
export function setMatchHeight(): void {
  $('.js-matchHeight').matchHeight();
}
